// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import POSType from '../../constants/POSType';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class POSChooser extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    value: PropTypes.string.isRequired,

    // param: String, the chosen POS
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  onSelect = (option) => {
    if (_.isNull(option)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(option.value)
    }
  };

  render() {
    const choices = POSType.getChoices();

    return (
      <div className="pos_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.value}
          options={choices}
          onChange={this.onSelect}
          clearable
          placeholder={I18n.tr('components.pos_chooser.placeholder')}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/POSChooser.js